// extracted by mini-css-extract-plugin
module.exports = {"root":"Clouds-module--root--3Ig4R","cloud":"Clouds-module--cloud--1A0E6"};